import { QualityControlFieldTitle, schValueType, schZoningCompliance } from '@aloft/toolkit-shared';

export type QualityControlFieldKind = 'text' | 'textarea' | 'select' | 'radio' | 'currency';

export type QualityControlFieldOption = {
  label: string;
  value: string;
};

export type QualityControlFieldDefinition = {
  title: QualityControlFieldTitle;
  kind: QualityControlFieldKind;
  isRequired: boolean;
  options?: QualityControlFieldOption[];
  tooltip?: string;
};

const zoningComplianceOptions: QualityControlFieldOption[] = schZoningCompliance.options.map(
  (value) => ({ label: value, value }),
);

const valueTypeOptions: QualityControlFieldOption[] = [
  { label: 'As-is', value: schValueType.enum['as-is'] },
  {
    label: 'Subject to repairs or alterations',
    value: schValueType.enum['subject-to'],
  },
];

export const QUALITY_CONTROL_FIELD_DEFINITIONS: Record<
  QualityControlFieldTitle,
  QualityControlFieldDefinition
> = {
  Zoning: { title: 'Zoning', kind: 'text', isRequired: true },
  'Zoning Compliance': {
    title: 'Zoning Compliance',
    kind: 'select',
    isRequired: true,
    options: zoningComplianceOptions,
  },
  'Parcel Number': { title: 'Parcel Number', kind: 'text', isRequired: true },
  'Legal Description': { title: 'Legal Description', kind: 'text', isRequired: true },
  'Market Condition Commentary': {
    title: 'Market Condition Commentary',
    kind: 'textarea',
    isRequired: true,
  },
  'Prior Sales Commentary': {
    title: 'Prior Sales Commentary',
    kind: 'textarea',
    isRequired: true,
  },
  'AIV / ARV Reconciliation Commentary': {
    title: 'AIV / ARV Reconciliation Commentary',
    kind: 'textarea',
    isRequired: true,
  },
  'Highest & Best Use Commentary': {
    title: 'Highest & Best Use Commentary',
    kind: 'textarea',
    isRequired: true,
  },
  'Revision / ROV Commentary': {
    title: 'Revision / ROV Commentary',
    kind: 'textarea',
    isRequired: true,
  },
  'As Is / Subject To': {
    title: 'As Is / Subject To',
    kind: 'radio',
    isRequired: true,
    options: valueTypeOptions,
  },
  'Total Cost to Cure': {
    title: 'Total Cost to Cure',
    kind: 'currency',
    isRequired: true,
    tooltip:
      'Major items only (i.e. soundness, security, livability). No cosmetic or minor deferred maintenance.',
  },
  'Total Cost to Cure Commentary': {
    title: 'Total Cost to Cure Commentary',
    kind: 'textarea',
    isRequired: true,
  },
  'All alerts': { title: 'All alerts', kind: 'text', isRequired: false },
};

export const getQualityControlFieldDefinition = (
  title: string,
): QualityControlFieldDefinition | undefined =>
  title in QUALITY_CONTROL_FIELD_DEFINITIONS
    ? QUALITY_CONTROL_FIELD_DEFINITIONS[title as QualityControlFieldTitle]
    : undefined;
